import { addressTypes } from '../models/address.ts'
import { addressLookupTypes } from '../models/address-lookup.ts'
import {
  vArray,
  vBoolean,
  vObject,
  vOpt,
  vOptional,
  vOptionalDef,
  type vOutput,
  vPicklist,
  vString,
  vStringToNumber,
} from '../validation/index.ts'

export const addressOwnerQuerySchema = vObject({
  accountId: vString(),
  vendorId: vOptional(vString()),
})
export type AddressOwnerQuery = vOutput<typeof addressOwnerQuerySchema>

export const deleteAddressesSchema = vObject({
  types: vArray(vPicklist(addressLookupTypes)),
  deleteAccountLocations: vOpt(vBoolean(), false),
})
export type DeleteAddressesDto = vOutput<typeof deleteAddressesSchema>

export const addressBookExportSchema = vObject({
  types: vArray(vPicklist(addressTypes)),
})
export type AddressBookExportDto = vOutput<typeof addressBookExportSchema>

export const atlasSearchSchema = vObject({
  search: vString(),
})
export type AtlasSearchQuery = vOutput<typeof atlasSearchSchema>

export const loadDocTokenQuerySchema = vObject({
  token: vOptional(vString()),
})
export type LoadDocTokenQuery = vOutput<typeof loadDocTokenQuerySchema>

export const carrierUsersSearchSchema = vObject({
  carrierId: vOptional(vString()),
  limit: vOptionalDef(vStringToNumber(), 20),
})
export type CarrierUsersSearchQuery = vOutput<typeof carrierUsersSearchSchema>
